module.exports = __webpack_public_path__ + "static/media/text-messages.4989c401.png";